import { call, select, fork, spawn, put } from "redux-saga/effects";
import { message } from "antd";
import ACTION from "../action";
import { ApiNames } from "../../api/api";
import { callApi } from "./networkActions";
import { actions } from "./sagaActions";
import { watchSignInActions } from "./authActions";
import { waitForLogin } from "@tailormed/common-client/store/saga/authSagas";
import initializeUserMetrics from "@tailormed/common-client/store/saga/services/userMetrics";
import { getAuthInstance, logout } from "@tailormed/common-client/services/auth";
import { selectIDPConfig, selectUser } from "../selector";
import { oktaConfig } from "../../constant/config";

function* getUser() {
  const loggedUserRes = yield callApi(ApiNames.LoggedUser);
  if (loggedUserRes && loggedUserRes.data) {
    const { data } = loggedUserRes;
    yield put(ACTION.setEnvironment(data.siteLicense.siteName));
    yield put(ACTION.setUser(data.users[0]));

    const notificationPreferencesRes = yield callApi(ApiNames.NotificationPreferences);
    if (notificationPreferencesRes) {
      yield put(ACTION.setNotificationPreferences(notificationPreferencesRes));
    } else {
      message.error("Failed to load notification preferences");
    }
  } else {
    message.error(`User is not allowed`);
    const idpConfig = yield select(selectIDPConfig);
    const user = yield select(selectUser);
    yield call(logout, user, idpConfig, oktaConfig.loginURI);
  }
}

function* startup() {
  const oktaAuth = getAuthInstance(oktaConfig.redirectUri);
  const token = oktaAuth.getAccessToken();
  yield call(getUser);
  yield spawn(initializeUserMetrics, { analytics: true, rum: true, token });
}

function* rootSaga() {
  yield fork(watchSignInActions);
  yield waitForLogin();
  yield fork(startup);
  yield spawn(actions);
}

export { rootSaga };
